import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import { communityCreatorPausePath, communityCreatorStagePath, newAccountPath } from "@travily/routes";
import { useCreatorTopBarActions } from "@/lib/wizard/use-creator-top-bar-actions";
import { useWizardForm } from "@/lib/wizard/use-wizard-form";
import { CommunityBioStepView } from "./show.view";

interface PageProps {
  stage_index: number;
  total_stages: number;
  stage_order: string[];
  bio: string | null;
  profileable_id: number;
}

type FormData = {
  bio: string;
};

const CommunityBioStep = ({ stage_index, stage_order, bio, profileable_id }: PageProps) => {
  const { form, currentStage, totalStages, onBack, onPrimary, primaryPending, onPause } = useWizardForm<FormData>({
    routes: {
      stageUrl: (stage) => communityCreatorStagePath(profileable_id, stage),
      entryUrl: newAccountPath(),
      pauseUrl: communityCreatorPausePath(profileable_id),
    },
    stageName: "bio",
    stageIndex: stage_index,
    stageOrder: stage_order,
    initialData: { bio: bio ?? "" },
  });

  const topBarActions = useCreatorTopBarActions({ onPause });

  return (
    <>
      <Head title={t("web.communities.creator.steps.bio.show.meta_title")}>
        <meta name="description" content={t("web.communities.creator.steps.bio.show.meta_description")} />
      </Head>
      <CommunityBioStepView
        currentStage={currentStage}
        totalStages={totalStages}
        onBack={onBack}
        topBarActions={topBarActions}
        onPrimary={onPrimary}
        primaryPending={primaryPending}
        bio={form.data.bio}
        onBioChange={(val) => form.setData("bio", val)}
      />
    </>
  );
};

export default CommunityBioStep;
